import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import '../../services/GlobalVariables';

const API_URL = global.SET_API_URL + 'attendanceSites/';

const initialState = {
    sites: [],
    assignments: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const getAttendanceSites = createAsyncThunk('attendanceSites/getAttendanceSites', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const getSingleAttendanceSite = createAsyncThunk('attendanceSites/getSingleAttendanceSite', async (siteID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${siteID}`);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const addAttendanceSite = createAsyncThunk('attendanceSites/addAttendanceSite', async (payload, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, payload);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const editAttendanceSite = createAsyncThunk('attendanceSites/editAttendanceSite', async (payload, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}${payload.siteID}`, payload);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const deleteAttendanceSite = createAsyncThunk('attendanceSites/deleteAttendanceSite', async (siteID, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}${siteID}`);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const getEmployeeSiteAssignments = createAsyncThunk('attendanceSites/getEmployeeSiteAssignments', async (_, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}assignments`);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const saveEmployeeSiteAssignments = createAsyncThunk('attendanceSites/saveEmployeeSiteAssignments', async (payload, thunkAPI) => {
    try {
        const result = await axios.post(`${API_URL}assignments`, payload);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

const attendanceSiteSlice = createSlice({
    name: 'attendanceSites',
    initialState,
    reducers: {
        resetAttendanceSiteState: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAttendanceSites.pending, (state) => { state.isLoading = true; state.isError = false; })
            .addCase(getAttendanceSites.fulfilled, (state, action) => { state.isLoading = false; state.sites = action.payload || []; })
            .addCase(getAttendanceSites.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; state.sites = []; })
            .addCase(getEmployeeSiteAssignments.fulfilled, (state, action) => { state.assignments = action.payload || []; })
            .addCase(addAttendanceSite.pending, (state) => { state.isLoading = true; state.isError = false; state.isSuccess = false; })
            .addCase(addAttendanceSite.fulfilled, (state, action) => { state.isLoading = false; state.isSuccess = true; state.message = action.payload?.message || 'Attendance site saved.'; })
            .addCase(addAttendanceSite.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; })
            .addCase(editAttendanceSite.pending, (state) => { state.isLoading = true; state.isError = false; state.isSuccess = false; })
            .addCase(editAttendanceSite.fulfilled, (state, action) => { state.isLoading = false; state.isSuccess = true; state.message = action.payload?.message || 'Attendance site updated.'; })
            .addCase(editAttendanceSite.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; })
            .addCase(deleteAttendanceSite.fulfilled, (state, action) => { state.isSuccess = true; state.message = action.payload?.message || 'Attendance site deleted.'; })
            .addCase(saveEmployeeSiteAssignments.pending, (state) => { state.isLoading = true; state.isError = false; state.isSuccess = false; })
            .addCase(saveEmployeeSiteAssignments.fulfilled, (state, action) => { state.isLoading = false; state.isSuccess = true; state.message = action.payload?.message || 'Assignments updated.'; })
            .addCase(saveEmployeeSiteAssignments.rejected, (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; });
    }
});

export const { resetAttendanceSiteState } = attendanceSiteSlice.actions;

export default attendanceSiteSlice.reducer;